import { render, staticRenderFns } from "./SelectTemplateForm.vue?vue&type=template&id=4b824d20&scoped=true"
import script from "./SelectTemplateForm.vue?vue&type=script&lang=js"
export * from "./SelectTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./SelectTemplateForm.vue?vue&type=style&index=0&id=4b824d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b824d20",
  null
  
)

export default component.exports